var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAACeUlEQVRYR+2YS07rMBSGbaeEMkFBAjGE7oAl3O6gLIAQQEjlId2yAtIVkAEUJESwxAJgB5QV0B3QMZNmBCh9+NqXhjZunDqJxUOkkw5qn3z5fc5/jgvBD/nAH8IJfidorWYbnvdss1MqFnXn4sJpqzoxpYpa1v4tIaDC4CAkTYzPy98S1DQP2hRw5R0UtDFulHLQLArkirJUyqIgvzdXNFc0tydFFfVtismyDv/0en1jcXG56Ti2l6bqh/NAZWYGtC4vGy1ZjaTtifZxi/bx62EfbxeLs2V+6JimaLVaW3178+9pnFUWp1Ag61dX53cysNKgprmHIYSbQVDa0ydg40B5yPcXhhjjsy2loDs7e5VeD96OB+VhRaBRkCyOpoEt121gpaAs2Pb2od3vD45FsFGgYkhUd91TWwbyv/qyC4N1cbAvL93m+JhHh+fyeE4GMTQtGWQq0DhlAUAGIcQY5h91BeIFhZMFMjWoCHba6aRR8qN4pwWP+z0qDUTrs0BGKmqa1WOE0ILs5UwGVhZyd3d/rduFf2nKPNBrTMgNQsUUNnXoGcZSKaoD8arFwcpCspj0+U9BTkOI6hiPXCEEypv63Jxekr3yRsEmgWQ29vrqP33kJNcMlIHyBaZp8Mh1zxzZGvhUUAbFhg72LZMy4y/x6aCyCvLrctC0yon25YqqVpSZve+DRyl72tg4qCFETkaLwR3dXNd1feLaoRoUAP8k+CeQxR4M4NHNzcjeQj7KrKXTee6oh0gekW82E/OoTO9O/thkO6I6WuTg/JWworYrnPCZXfh+l96TBmvJ9Ei3ulBArfn5JSzqaImvIukwsu/KQbNrGI7wDx9v2Tr2NmuDAAAAAElFTkSuQmCC",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSign);
export default __webpack_public_path__ + "static/media/DownloadSign.77b10310a21a55dbd975223a43861aaa.svg";
export { ForwardRef as ReactComponent };